import React from 'react';
import { Card, CardMedia, CardContent, Typography, Box, Chip } from '@mui/material';
import styles from './PostCard.module.css';

interface PostCardProps {
  post: any;
  onClick: () => void;
}

const PostCard: React.FC<PostCardProps> = ({ post, onClick }) => {
  return (
    <Card className={styles.postCard} onClick={onClick}>
      {post.image && (
        <CardMedia
          component="img"
          height="200"
          image={post.image}
          alt={post.title}
          className={styles.postCardImage}
        />
      )}
      <CardContent className={styles.postCardContent}>
        <Typography variant="h6" className={styles.postCardTitle}>
          {post.title}
        </Typography>
        <Typography variant="body2" className={styles.postCardDescription}>
          {post.description}
        </Typography>
        <Box className={styles.postCardTags}>
          {post.tags.map((tag: string) => (
            <Chip 
              key={tag} 
              label={tag} 
              size="small" 
              className={styles.postTag}
            />
          ))}
        </Box>
        <Typography variant="caption" className={styles.postCardDate}>
          {new Date(post.date).toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default PostCard;